<template>
  <section v-if="items.length">
    <v-container>
      <TitleWidget>
        {{ title }}
      </TitleWidget>

      <v-row class="mt-6 mt-md-8" justify="center">
        <v-col
          v-for="(item, keyItems) in items"
          :key="keyItems"
          cols="6"
          sm="4"
          md="3"
        >
          <ServiceCard v-bind="item" />
        </v-col>
      </v-row>

      <ButtonWidget
        class="mt-6 mt-md-8"
        :to="path"
        align="center"
        color="primary"
        text-color="secondary"
      >
        Saiba mais
      </ButtonWidget>
    </v-container>
  </section>
</template>

<script>
import TitleWidget from "../widgets/TitleWidget.vue";
import ServiceCard from "../cards/ServiceCard.vue";
import ButtonWidget from "../widgets/ButtonWidget.vue";
import { formatToURL } from "../../utils/formatToURL";

const _config = {
  mod: "services",
  path: "/servicos",
};

const _data = {
  title: "Nossos Serviços",
  path: _config.path,
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list.map(({ id, img, title }) => ({
        img,
        title,
        to: `${_config.path}/${formatToURL(title)}-${id}`,
      }));
    },
  },
  created() {
    this.$rest(_config.mod).get();
  },
  components: {
    TitleWidget,
    ServiceCard,
    ButtonWidget,
  },
};
</script>
